<template>
    <ul class="profile-educations__list">
        <EducationFragment
            v-for="element in educationSectionState"
            :key="`education--${element.id}`"
            :model-value="element"
            :is-sample="false"
            :is-edit-mode="false"
        />
    </ul>
</template>

<script setup lang="ts">
    import {useEducationSectionState} from '~/features/education/composables/useEducationSectionState';
    import EducationFragment from '~/features/education/ui/EducationFragment.vue';

    // State
    const educationSectionState = useEducationSectionState();
</script>

<style lang="scss" scoped>
    .profile-educations__list {
        list-style-type: none;
    }
</style>
